<template>
  <div class="report-service" v-if="load">
    <div class="report" v-if="$route.name==='Limits'">
    <limit-menu v-model="date"></limit-menu>
    <div class="main">
      <h2 class="main-title">Стан лімітів на {{ date | formatOnlyDate}}</h2>
      <div class="balance">
        <div class="block">
          <div v-tooltip.top-center="''" class="cart">
            <div>Сума лімітів: &nbsp;</div>
            <div v-for="total in limits.cardLimitTotal.cardLimitTotals" :key="total.limitType">
              <template v-if="total.limitType===2">
                Гривні
              </template>
              <template v-if="total.limitType===3">
                Літри
              </template>
              <b>{{total.totalLimit | toCurrency}}</b>
            </div>
          </div>
          <div @click="service()" v-tooltip.top-center="''"  class="cart cart-link">
            <div>
            <span>Сума використаних лімітів:</span>
              <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
              </svg>
            </div>
            <div v-for="total in limits.cardLimitTotal.cardLimitTotals" :key="total.limitType">
              <template v-if="total.limitType===2">
                Гривні
              </template>
              <template v-if="total.limitType===3">
                Літри
              </template>
              <b>{{total.totalLimitUsed | toCurrency}}</b>
            </div>


          </div>
          <div class="cart">
            <div>Сума залишка лімітів:: &nbsp;</div>
            <div v-for="total in limits.cardLimitTotal.cardLimitTotals" :key="total.limitType">
              <template v-if="total.limitType===2">
                Гривні
              </template>
              <template v-if="total.limitType===3">
                Літри
              </template>
              <b>{{total.totalLimitRest | toCurrency}}</b>
            </div>
          </div>
          <div @click="serviceResults()" v-tooltip.top-center="''" class="cart cart-link" :class="balanceTurnover.restOut  < 0 ? 'notice' : ''">
            <span>Залишок балансу (&#8372;): &nbsp;</span><b :class="balanceTurnover.restOut < 0 ? 'notice-text' : ''">{{balanceTurnover.restOut | toCurrency}}</b>
            <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.5 9L0.73686 0.75L10.2631 0.75L5.5 9Z"/>
            </svg>
          </div>
        </div>
      </div>

    </div>
    </div>
    <div class="main-header flex-justify"  v-if="$route.name==='Limits'">
      <div class="inner-addon">
        <button v-if="item.length >0" @click="item=[]" class="dropbtn" v-tooltip.top-center="'Скинути всі фільтри'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </button>
      </div>
      <div class="header-right">
        <div class="select" >
          <select v-model="limit">
            <option value=10>10</option>
            <option value=20>20</option>
            <option value=40>40</option>
            <option value=50>50</option>
            <option value=100>100</option>
          </select>
        </div>
      </div>
    </div>
    <section class="limit" v-if="$route.name==='Limits'">
      <header>
        <div class="col-td">
          <div class="dropdown">
            <button @click="isActive=!isActive" class="dropbtn" >
              <svg :class="{active: item.length>0}" width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 9V15L12 18V9L17 1H1Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <div id="myDropdown" :class="{show: isActive}" class="dropdown-content">
              <div class="addon left-addon">
                <button  @click="item=[]" class="dropbtn" v-tooltip.top-center="'Скинути'" ><svg class="hover" width="30" height="24" viewBox="0 0 30 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4L9 12V18L15 21V12L20 4H4Z" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M29 12L20 21M20 12L29 21" stroke="#BDBDBD" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                </button>
                <input type="text" placeholder="Пошук.." class="myInput" v-model="search">
                <svg class="glyphicon" width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="13.5" cy="8.5" r="8" fill="white" stroke="#C4C4C4"/>
                  <line x1="8.06066" y1="14.0607" x2="1.06066" y2="21.0607" stroke="#C4C4C4" stroke-width="3"/>
                </svg>
              </div>
              <div class="checkbox" v-for="card in cardList" :key="card.cardNo" >
                <input type="checkbox" class="custom-checkbox" v-model="item" :id="'category_' + card.cardNo" :value="card.cardNo"  />
                <label :for="'category_' + card.cardNo">{{ card.cardNo }} - {{ card.cardDescription }}</label>
              </div>
              <!--              <a v-for="card in filteredList" :key="card" :href="'#'+card">{{card}}</a>-->
            </div>
          </div>
          <a @click.stop="sort=OrderByCardNo.reverse()[0]">Картка/Тримач
            <span class="arrow">
                <svg :class="{active: sort==2}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 6L6 1L1 6" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg :class="{active: sort==1}" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#C4C4C4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              </span>
          </a>
        </div>
        <div class="col-td">Статус</div>
        <div class="col-td">Вид пального, послуга</div>
        <div class="col-td">Тип ліміту</div>
        <div class="col-td">Період</div>
        <div class="col-td">ЛІМІТ</div>
        <div class="col-td">Вик.</div>
        <div class="col-td">Залишилось</div>
      </header>

      <template  v-for="(tr, i) in limits.data" >
        <div class="table-row" :key="i">
          <div class="col-td desktop" style="width: 15%" >
            <div class="links">
              <a> {{tr.cardNo}} - {{tr.cardDescription}}</a>
              <ul class="dropdown-child">
                <li>
                  <router-link :to="'/limits/'+ tr.cardNo +'/history'">Історія змін по картці</router-link>
                </li>
                <li>
                  <router-link :to="'/limits/'+ tr.cardNo +'/holder'">Історія змін тримача</router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-td desktop">
              <router-link :to="'/limits/'+tr.cardNo+ '/status'">{{tr.cardStatus}}</router-link>

          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.nameGoods }}</div>
            </template>
          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.limitTypeText}}</div>
            </template>
          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.period }}</div>
            </template>
          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.limit }}</div>
            </template>
          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.limitUsed }}</div>
            </template>
          </div>
          <div class="col-td desktop">
            <template  v-for="(td, i ) in tr.cardLimits">
              <div :key="i">{{td.limitRest }}</div>
            </template>
          </div>


<!--            <div :key="index" class="col-td desktop"></div>-->
<!--            <div :key="index" class="col-td desktop">{{td.period }}</div>-->
<!--            <div :key="index" class="col-td desktop">{{td.limit | toCurrency }}</div>-->
<!--            <div :key="index" class="col-td desktop">{{td.limitUsed | toCurrency }}</div>-->
<!--            <div :key="index" class="col-td desktop">{{td.limitRest | toCurrency }}</div>-->
        </div>
      </template>
    </section>
    <div class="container" v-if="$route.name==='Limits'">

      <paginate v-if="limits.cardLimitTotal.totalCount/limit > 1"
          :page-count="Math.ceil(limits.cardLimitTotal.totalCount/limit)"
          :click-handler="changePage"
          :page-range="4"
          :margin-pages="4"
          :initial-page="page"
          :prev-text="'Попередня'"
          :next-text="'Наступна'"
          :container-class="'pagination'">
      </paginate>
      <div class="pagination-info">
        Показується з {{page * limit - limit + 1}} по {{limits.pageTotal.countOnPage === Number(limit) ? page * limit :  limits.cardLimitTotal.totalCount}} із {{ limits.cardLimitTotal.totalCount }}
      </div>
    </div>
    <div v-if="$route.name==='Limits'">
      <br>
      <button @click="limitDownload">Скачать Exel 1С формат</button>
    </div>
    <router-view/>
  </div>
</template>
<script>

import LimitMenu from '../components/LimitMenu'
import  moment from "moment"
import Paginate from 'vuejs-paginate'
import qs from "qs";
moment.defineLocale('uk', null)
export default {
  name: 'Limit',
  components: {
    LimitMenu,
    Paginate
  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
    page: function () {
      // this.load = false
      this.getData()
    },
    limit: function () {
      // this.load = false
      this.getData()
      this.page = 1
    },
    item: function () {
      // this.load = false
      this.getData()
    },
    sort: function () {
      // this.load = false
      this.getData()
    },
  },
  data() {
    return {
      OrderByCardNo: [2,1],
      cards: [],
      search:'',
      sort: 1,
      isActive: false,
      searchText: 'Test',
      item: [],
      datacollection: null,
      load: false,
      typeReport: "table",
      balanceTurnover: null,
      limits: [],
      limit: 10,
      page: 1,
      totalTransactionsByGood: {},
      highlighted: {},
      date:  new Date(),
    }
  },
  created() {
    this.getData()
  },
  mounted () {

  },
  computed:{
    cardList() {
      return this.cards.filter(card => {
        return card.cardNo.toLowerCase().includes(this.search.toLowerCase()) || card.cardDescription.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    limitDownload: function () {

      this.axios.get('/userservice/v1/Card/limits-download', {params:
            {onDate: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00',},
        responseType: 'blob'}
      )
          .then(( data ) => {
            const file = data.data
            const downloadUrl = window.URL.createObjectURL(new Blob([file]));

            const link = document.createElement('a');

            link.href = downloadUrl;

            link.setAttribute('download', "Стан лімітів на " + moment(this.date).format('DD-MM-YYYY')  + '.xlsx'); //any other extension
            document.body.appendChild(link);

            link.click();

            link.remove();

          })
          .catch(error => {
            if (error.response && error.response.status === 401) {
              this.$store.dispatch("logout")
            } else {
              console.log(error);
              this.errored = true;
            }
          })
    },
    changePage: function (pageNum){
      this.page = pageNum
    },
    service: function (){
      this.$router.push('/service');
    },
    serviceResults: function () {
      this.$router.push('/service-results');
    },
    getData: function (){
      if (this.$route.name==='Limits'){
        this.axios.all([
          this.axios.get('/userservice/v1/User/balance-turnover', {params: {begDate: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date).format('YYYY-MM-DD') + ' 23:59:59'}}),
          this.axios.get('/userservice/v1/Card'),
          this.axios.get('/userservice/v1/Card/limits', {params:
                {
                  onDate: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00',
                  top: this.limit,
                  page: this.page,
                  sortingLimit: this.sort,
                  cardNoList: this.item,
                },
            paramsSerializer: params => {return qs.stringify(params)}
          }),
          //this.axios.get('https://map.svitpro.com.ua/messages-api')
        ]).then(
            this.axios.spread((balanceTurnover, cards, limits) => {
              this.balanceTurnover = balanceTurnover.data
              this.cards = cards.data
              this.limits = limits.data
              //this.transactionsByGood = transactionsByGood.data.data
              //this.totalTransactionsByGood =  transactionsByGood.data.total
              //  this.info = info.data
            })
        )
            .catch(error => {
              console.log('error_get_data');
              console.log(error);
              this.errored = true;
            })
            .finally(() => (
                this.load = true)
            )
      } else {
        this.load = true
      }
    },
  }
}
</script>
<style>
header .col-td:first-child,
.table-row .col-td:first-child {
  padding-left: 6px;
}
.cart div {
  min-width: 159px;
  border-bottom: 1px #C4C4C4 solid;
  line-height: 2.5em;
  flex-direction: column;
  display: flex;
}
.cart div:last-child {
  border: none;
}
.limit .col-td {
  box-sizing: border-box;
  padding: 0;
}
.col-td div {
  border-bottom: 1px #C4C4C4 solid;
  line-height: 2.5em;
}
.col-td div:last-child{
  border: none;
}
.form_radio_btn {
  display: inline-block;
  margin-right: 10px;
}
.form_radio_btn input[type=radio] {
  display: none;
}
.form_radio_btn label {
  display: inline-block;
  cursor: pointer;
  padding: 10px 20px;
  line-height: 34px;
  border: none;
  border-radius: 20px;
  user-select: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
  /* or 146% */
  text-align: center;
  text-transform: uppercase;
  font-feature-settings: 'cpsp' on;
  color: #222160;
  background: #E5E5E5;
}

/* Checked */
.form_radio_btn input[type=radio]:checked + label {
  background: #222160;
  color: #E5E5E5;
}

/* Hover */
.form_radio_btn label:hover {
  color: #666;
}
.grafic {
  height: 335px;
  background: #F5F5F5;
  margin-top: 30px;
}
.row-right {
  display: flex;
  justify-content: end;
}


.right-inner-addon span.text{
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 19px;
/* or 146% */
  font-feature-settings: 'cpsp' on;
  color: #222160;
  margin: 5px;
}
.report .main {
  //padding-top: 6em;
  margin-left: 25px;
}
 .report {
   display: flex;
   flex-direction: row;
   justify-content: space-between;
   width: 80%;
   align-self: center;
   justify-self: center;
 }
</style>